// src/PrivacyPolicy.js
import React from 'react';
import './privacypolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>IMPRESSUM/TERMS AND CONDITIONS</h1>

      <h2>IMPRESSUM</h2>
      <p>Ada Jungblut FZCO</p>
      <p>Address: Dubai Silicon Oasis</p>
      <p>Phone: +971585915922</p>
      <p>Managing Director: Wassili Jungblut</p>
      <p>Responsible for the content: Wassili Jungblut</p>

      <h2>Data Collection</h2>
      <p>We collect information to provide better services to our users. This includes:</p>
      <ul>
        <li><strong>Personal Information:</strong> Name, email address, and contact details provided during registration.</li>
        <li><strong>Usage Data:</strong> Information about how you use our app, including your interactions, preferences, and usage patterns.</li>
        <li><strong>Device Information:</strong> Information about the device you use to access our app, such as device type and operating system.</li>
      </ul>

      <h2>Use of Your Data</h2>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li><strong>To Provide and Maintain Our Services:</strong> Ensuring our app functions as intended and to improve and personalize your experience.</li>
        <li><strong>To Improve Our Services:</strong> Analyzing how users interact with our app to enhance its functionality and features.</li>
        <li><strong>To Process Transactions:</strong> Managing and processing payments for subscriptions.</li>
        <li><strong>To Comply with Legal Obligations:</strong> Adhering to applicable laws and regulations.</li>
      </ul>
      <p><strong>Information Sharing:</strong> We do not share your personal information with third parties.</p>

      <h2>Information Security</h2>
      <p>We implement appropriate security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. These measures include internal reviews of our data collection, storage, and processing practices, as well as physical security measures to guard against unauthorized access to systems where we store personal data. However, no method of transmission over the internet or electronic storage is 100% secure.</p>

      <h2>Changes to This Policy</h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date at the top. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

      <h2>Service Description</h2>
      <p>We provide the creation of a personalized Energy Map based on your birth date. This map reveals your unique chakra energies and provides insights into how they influence different aspects of your life.</p>

      <h2>Governing Law</h2>
      <p>All services provided by Ada Jungblut FZCO are subject to the law of the United Arab Emirates.</p>
      <p>All content on this website is copyrighted. Reproduction of any content, in whole or in part, is strictly prohibited without prior written consent from Ada Jungblut FZCO.</p>
    </div>
  );
};

export default PrivacyPolicy;
